import { render, staticRenderFns } from "./consultingPage.vue?vue&type=template&id=74f99414&scoped=true"
import script from "./consultingPage.vue?vue&type=script&lang=js"
export * from "./consultingPage.vue?vue&type=script&lang=js"
import style0 from "./consultingPage.vue?vue&type=style&index=0&id=74f99414&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f99414",
  null
  
)

export default component.exports